export const TUTOR_VOICES = {
  PIPER_EN_US_AMY_LOW: 'PIPER_EN_US_AMY_LOW',
  PIPER_EN_US_DANNY_LOW: 'PIPER_EN_US_DANNY_LOW',
  PIPER_EN_US_ELLIOT_MILLER: 'PIPER_EN_US_ELLIOT_MILLER',
  PIPER_EN_UK_CORI_SAMUEL: 'PIPER_EN_UK_CORI_SAMUEL',
  PIPER_EN_US_KATHLEEN_LOW: 'PIPER_EN_US_KATHLEEN_LOW',
  PIPER_EN_UK_ELIZABETH_KLETT: 'PIPER_EN_UK_ELIZABETH_KLETT',
  PIPER_EN_US_JOHN_VAN_STAN: 'PIPER_EN_US_JOHN_VAN_STAN',
};
